import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let PaymentServiceController = {
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-payment/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    listPayment: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-payment/list-payment`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    allPaymentByStudent: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-payment/all-payment-by-student`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
}

export default PaymentServiceController
